import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import enableFormsFunctionality from './forms-common';
/**
 * Enables the "discovery flight" page functionality.
 */
const enableDiscoveryFlightFunctionality = () => {
    if ($('#discovery-flight').length === 0) {
        return;
    }
    /**
     * The "discovery flight" form.
     */
    const discoveryFlightForm = $('#discovery-flight-form');
    // Attempts to submit the form after receiving the captcha token.
    window.captchaCallback = (_token) => {
        discoveryFlightForm.trigger('submit');
    };
    // Sets up the form submission functionality
    window.onloadCaptcha = () => {
        discoveryFlightForm.validate();
        // Re-parse the form for validation
        discoveryFlightForm.removeData('validator');
        discoveryFlightForm.removeData('unobtrusiveValidation');
        $.validator.unobtrusive.parse(discoveryFlightForm);
        // Enable the submit button
        const btn = $('.btn', discoveryFlightForm);
        btn.prop('disabled', false);
        // Execute the captcha when the button is clicked (and the form is valid)
        btn.on('click', e => {
            e.preventDefault();
            if (discoveryFlightForm.valid()) {
                hcaptcha.execute();
            }
        });
    };
    enableFormsFunctionality();
};
export default enableDiscoveryFlightFunctionality;
